module.exports = __webpack_public_path__ + "img/Retenciones.5db5baf2.png";